var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaseIconEnt(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.06,
    height: 17.062,
    viewBox: "0 0 17.06 17.062",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_488385",
    "data-name": "Group 488385",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180784",
    "data-name": "Path 180784",
    d: "M265.725,139.189q0,1.815,0,3.631a1.224,1.224,0,0,1-1.3,1.319q-2.615.01-5.229,0a1.2,1.2,0,0,1-1.277-1.269q-.01-3.7,0-7.395a1.219,1.219,0,0,1,1.309-1.276q2.6,0,5.2,0a1.238,1.238,0,0,1,1.3,1.293C265.727,136.725,265.725,137.957,265.725,139.189Zm-1.065-.028q0-1.731,0-3.463c0-.434,0-.435-.419-.435-1.62,0-3.241.007-4.861-.006-.3,0-.406.08-.4.393q.017,3.53,0,7.059c0,.265.066.372.353.371q2.481-.017,4.961,0c.3,0,.377-.1.374-.389C264.653,141.514,264.66,140.338,264.66,139.161Z",
    transform: "translate(-248.666 -134.197)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180785",
    "data-name": "Path 180785",
    d: "M126.977,245.96c0,1.177,0,2.354,0,3.531a1.247,1.247,0,0,1-1.389,1.4q-2.531,0-5.063,0a1.251,1.251,0,0,1-1.358-1.372q0-3.614,0-7.228a1.227,1.227,0,0,1,1.312-1.341q2.6-.009,5.2,0a1.208,1.208,0,0,1,1.3,1.314C126.982,243.5,126.977,244.728,126.977,245.96Zm-1.068-.05c0-1.188,0-2.375,0-3.563,0-.236-.062-.338-.318-.337q-2.514.013-5.028,0c-.267,0-.341.1-.34.353q.011,3.546,0,7.093c0,.3.108.376.39.375,1.632-.01,3.263-.014,4.895,0,.338,0,.408-.122.4-.427C125.9,248.241,125.91,247.076,125.91,245.91Z",
    transform: "translate(-119.166 -233.831)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180786",
    "data-name": "Path 180786",
    d: "M123.073,139.876c-.866,0-1.732.005-2.6,0a1.231,1.231,0,0,1-1.318-1.336q0-1.515,0-3.031a1.241,1.241,0,0,1,1.319-1.309q2.6,0,5.2,0a1.216,1.216,0,0,1,1.292,1.259q.016,1.582,0,3.164a1.2,1.2,0,0,1-1.26,1.252C124.827,139.884,123.949,139.876,123.073,139.876Zm.017-4.613c-.843,0-1.687.005-2.53,0-.235,0-.344.064-.342.32q.014,1.464,0,2.929c0,.24.1.3.321.3q2.53-.007,5.059,0c.237,0,.306-.092.3-.316-.008-.965-.01-1.931,0-2.9,0-.265-.095-.345-.352-.342C124.731,135.271,123.91,135.263,123.089,135.263Z",
    transform: "translate(-119.156 -134.197)",
    fill: "#8e92a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_180787",
    "data-name": "Path 180787",
    d: "M261.8,304.958c.855,0,1.71,0,2.564,0a1.235,1.235,0,0,1,1.338,1.349q0,1.5,0,3a1.245,1.245,0,0,1-1.332,1.33q-2.581,0-5.162,0a1.226,1.226,0,0,1-1.314-1.306q-.011-1.532,0-3.064a1.211,1.211,0,0,1,1.309-1.306C260.073,304.953,260.939,304.958,261.8,304.958Zm0,1.068c-.843,0-1.687,0-2.53,0-.221,0-.321.061-.319.3q.014,1.464,0,2.929c0,.251.1.324.336.323q2.5-.011,4.993,0c.284,0,.361-.106.357-.373-.012-.932-.014-1.864,0-2.8,0-.286-.077-.393-.375-.387C263.452,306.037,262.63,306.026,261.809,306.026Z",
    transform: "translate(-248.648 -293.577)",
    fill: "#8e92a4"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaseIconEnt);
export default __webpack_public_path__ + "static/media/case_icon_ent.6fa9322066cf488dbca3fbf206d0e62a.svg";
export { ForwardRef as ReactComponent };